@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    (close)="cancelClick()"
    [width]="1024"
    (contentScrolled)="contentScrolled()"
    [noHeaderBorder]="true"
    [removeHeaderBottomPadding]="true">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">{{ channelTypeDisplay }} - {{ selectedTemplate?.name }}</h5>
        <div
          class="dialog-close"
          (click)="close()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
      <div style="width: 100%">
        <topo-tabs
          [selectedTabIndex]="selectedTabIndex"
          [tabs]="tabs"
        (selectedTabIndexChanged)="tabChanged($event)"></topo-tabs>
      </div>
    </div>
    <div class="modal-body">
      <div
        [hidden]="selectedTabIndex !== 0"
        style="min-height: calc(100vh - 200px)">
        @if (showSubject) {
          <div>
            <div class="label">{{ 'MAP.SUBJECT' | translate }}</div>
            <div class="mb-2">
              <input
                type="text"
                class="input is-medium"
                name="subject"
                [(ngModel)]="subject" />
            </div>
          </div>
        }
        <div class="label">{{ 'MAP.MESSAGE-TYPE' | translate : { channelTypeDisplay: channelTypeDisplay } }}</div>
        <topo-template-builder
          [isFullHeight]="true"
          [showEditAction]="true"
          [showDeleteAction]="true"
          [showCopyAction]="false"
          [enableDrag]="false"
          [mapImage]="mapImage"
          [selectedAssets]="assets"
          [showLetsBuild]="false"
          [enableMentions]="enableUserMentions"
          [mentionSearch]="getUserList.bind(this)"
          [showSlackHeader]="showSlackHeader"
          [showMicrosoftTeamsHeader]="showMicrosoftTeamsHeader"
          [headerDatasetType]="headerDatasetType"
          [headerDatasetName]="dataset?.name"
        [slackHeaderName]="document?.summary ?? document?.name ?? document?.first_name + ' ' + document?.last_name"></topo-template-builder>
      </div>
      <div
        [hidden]="selectedTabIndex !== 1"
        style="min-height: calc(100vh - 200px)">
        <div class="label">{{ 'MAP.TO' | translate }}</div>
        <div class="mb-3">
          <topo-recipient-select
            placeholder="{{ 'MAP.ENTER-PEOPLE-GROUPS' | translate }}"
            [disabled]="toReadOnly"
            [(ngModel)]="toSelectedRecipients"
          [channelType]="selectedTemplate.channelType"></topo-recipient-select>
        </div>
        @if (showCC) {
          <div>
            <div class="label">{{ 'MAP.CC' | translate }}</div>
            <div class="mb-3">
              <topo-recipient-select
                placeholder="{{ 'MAP.ENTER-PEOPLE-GROUPS' | translate }}"
                [disabled]="ccReadOnly"
                [(ngModel)]="ccSelectedRecipients"
              [channelType]="selectedTemplate.channelType"></topo-recipient-select>
            </div>
          </div>
        }
        <div class="label">{{ 'MAP.CONTACTS-SELECTED-ASSETS' | translate }}</div>
        <div class="mt-1"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <div>
            @if (!isDrawn) {
              <div
                class="select is-medium ">
                <select
                  [(ngModel)]="distanceValue"
                  name="distance"
                  (change)="onChange()">
                  @for (option of distanceOptions; track option.value) {
                    <option
                      [ngValue]="option.value">
                      {{ 'MAP.ASSETS-WITHIN' | translate : { distance: option.value, unit: longDistanceUnit } }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (isDrawn) {
              <div
                >
                {{ 'MAP.WITHIN-LASSO' | translate }}
              </div>
            }
          </div>
          <div class="section-message mx-4">
            {{ assetContactsForDisplay?.length }} {{ 'MAP.CONTACTS-SELECTED-ASSETS' | translate }} {{ 'MAP.WITH-VALID-EMAIL' | translate }}
          </div>
        </div>
        <div style="position: relative !important; top: 200px">
          <ngx-spinner
            bdColor="rgba(0,0,0,.1)"
            size="medium"
            color="#4D33CC"
            type="ball-clip-rotate"
            [fullScreen]="false"
            [zIndex]="998">
            <h5
              style="position: absolute !important; top: 36px; right: -184px; width: 300px"
              class="mx-4 my-4">
              {{ 'MAP.GATHERING-CONTACTS' | translate }}
            </h5>
          </ngx-spinner>
        </div>
        @if (!_isClosestAssetWorking && assetContactsForDisplay?.length === 0) {
          <div>
            <div
              fxLayout="row"
              fxLayoutAlign="center center"
              style="margin-top: 200px">
              <img src="https://files.topo.ai/images/email/illustration_no-results.svg" />
            </div>
            <div
              fxLayout="row"
              fxLayoutAlign="center center">
              <h5
                fxLayout="row"
                fxLayoutAlign="center center"
                class="mx-4 my-4"
                style="width: 300px">
                {{ 'MAP.NO-CONTACTS' | translate }}
              </h5>
            </div>
          </div>
        }
        @if (!_isClosestAssetWorking && assetContactsForDisplay?.length > 0) {
          <topo-table
            [showHeader]="false"
            [showNewItem]="false"
            [showPager]="false"
            [showSearch]="false"
            [showCount]="false"
            [useSmallHeaderLabel]="true"
            [enableDragDrop]="false"
            headerLabel="{{ 'MANAGEMENT.DATASETS.PICKLIST-VALUES' | translate }}"
            itemName="{{ 'MANAGEMENT.DATASETS.DATAFEED' | translate }}"
            [items]="assetContactsForDisplay"
            (sort)="onSort($event)"
            (checkboxSelected)="selectAll($event)">
            <topo-columns>
              <topo-column
                hasCheckbox="true"
                [isChecked]="isAllChecked"
                [cellStyle]="{ width: '20px' }">
                <ng-template let-item="item">
                  <label
                    class="checkbox"
                    style="padding-top: 10px; padding-bottom: 10px">
                    <input
                      id="email-{{ item.emailAddr }}-{{ item.name }}"
                      type="checkbox"
                      name="email-{{ item.emailAddr }}-{{ item.name }}"
                      (click)="onIsActiveClick($event, item)"
                      class="checkbox" />
                    <span></span>
                  </label>
                </ng-template>
              </topo-column>
              <topo-column
                label="{{ 'MAP.CONTACT' | translate }}"
                [cellStyle]="{ width: '170px' }"
                sortField="Email">
                <ng-template let-item="item">
                  {{ item.emailAddr }}
                </ng-template>
              </topo-column>
              <topo-column
                label="{{ 'MANAGEMENT.DATASETS.DATASET-TYPE-2-SINGULAR' | translate }}"
                [cellStyle]="{ width: '230px' }"
                sortField="Name">
                <ng-template let-item="item">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    @if (!item?.layer?.isCustomIcon) {
                      <div
                        class="asset-icon"
                  [style]="
                    'background-color:' +
                    (item.layer?.color || '#FFFFFF') +
                    ';color: ' +
                    (item.pinStyle?.iconStrokeColor || '#FFFFFF') +
                    ';'
                  "
                        fxLayout="row"
                        fxLayoutAlign="space-around center">
                        <div
                          class="material-icons"
                          style="font-size: 16px">
                          {{ item.layer?.iconPath }}
                        </div>
                      </div>
                    }
                    @if (!!item?.layer?.isCustomIcon) {
                      <div
                        class="asset-icon"
                        [style]="'background-color:' + (!item ? '#FFFFFF' : item.layer?.color)">
                        <img
                          [src]="item.layer?.iconPath | safeUrl"
                          style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
                      </div>
                    }
                    <div class="asset-name ml-2">
                      {{ item.name }}
                    </div>
                  </div>
                </ng-template>
              </topo-column>
              <topo-column
                label="{{ 'DATATYPES.DISTANCE' | translate }}"
                [cellStyle]="{ width: '50px' }"
                sortField="Distance">
                <ng-template let-item="item">
                  {{ item.distanceText }}
                </ng-template>
              </topo-column>
            </topo-columns>
          </topo-table>
        }
      </div>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'MAP.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-primary"
            (click)="sendClick()">
            {{ 'MAP.SEND' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}
